import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Input,
  ComponentRef,
  AfterViewInit,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { widgetsColumn } from './widgets-column.component';
import { AppComponent, ModeViewClass } from '../app.component';
import { widgetContainerComponent } from './widget-container.component';
import { mainViewComponent } from './main-view.component';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'columnDrag',
  templateUrl: 'columnDrag.template.html'
})
export class columnDragComponent extends BaseComponent implements AfterViewInit {
  @Input() class: string;
  @Input() bagName: string;
  @Input() grigLayout: string;

  reloadSubject: Observable<boolean>;

  @ViewChild('parent', { read: ViewContainerRef, static: true })
  parent: ViewContainerRef;

  components = [];
  componentsViews: Array<ComponentRef<any>> = [];
  columns: Array<ComponentRef<widgetsColumn>> = [];
  modeView: String = '';
  mainViewComponent: mainViewComponent;
  columnIndex: number;

  constructor(
    private appComponent: AppComponent,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.subscribe(this.appComponent.modeViewObservable,
      mode => {
        if (mode != this.modeView) {
          this.modeView = mode;
          if (this.parent) this.ngAfterViewInit();
        }
      });
  }


  public caluclateNumColumns(): number {
    if (this.modeView == ModeViewClass.MODE_VIEW_LG) return 4;
    if (this.modeView == ModeViewClass.MODE_VIEW_MD) return 3;
    if (this.modeView == ModeViewClass.MODE_VIEW_SM) return 2;
    else return 1;
  }

  ngAfterViewInit(): void {
    this.parent.clear();
    let columnsCount = this.caluclateNumColumns();
    // TODO: REVISAR EL CÁLCULO DEL NÚMERO DE COLUMNAS. AQUI ESTA LA CLAVE DE LA ESTRUCTURA DE LA PANTALLA
    // if (this.components.length === 1) {
    //   columnsCount = 1;
    // }
    columnsCount = 1;
    for (let i = 0; i < columnsCount; ++i) {
      let factory = this.componentFactoryResolver.resolveComponentFactory(
        widgetsColumn
      );
      this.columns[i] = this.parent.createComponent(factory);
      this.columns[i].instance.columnsCount = columnsCount;
    }

    for (let i = 0; i < this.components.length; ++i) {
      let factory = this.componentFactoryResolver.resolveComponentFactory(
        widgetContainerComponent
      );
      //let factory = this.componentFactoryResolver.resolveComponentFactory(this.components[i].component);
      this.componentsViews[i] = this.columns[
        i % columnsCount
      ].instance.container.createComponent(factory);
      let widgetContainer: widgetContainerComponent = this.componentsViews[i]
        .instance;
      widgetContainer.reloadSubject = this.reloadSubject;
      widgetContainer.insertWidget(this.components[i].component, this.components[i].params, this);
      widgetContainer.position = i;
      widgetContainer.isLast = i == this.components.length - 1;
      widgetContainer.mainViewComponent = this.mainViewComponent;
      if (this.components[i].params) {
        for (let key in this.components[i].params) {
          if (key && key != 'layoutClass') {
            widgetContainer.widget.instance[key] = this.components[i].params[
              key
            ];
          }
        }
      }
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    // eliminar referencias para limnpiar objeto
    this.components = undefined;
    this.componentsViews = undefined
    this.columns = undefined
    this.mainViewComponent = undefined
  }

  moveWidgetDown(index: number) {
    this.mainViewComponent.moveWidgetDown(this.columnIndex, index);
  }

  moveWidgetUp(index: number) {
    this.mainViewComponent.moveWidgetUp(this.columnIndex, index);
  }

  public insertComponent(component: any, params: any): void {
    this.components.push({ component: component, params: params });
  }

}
